module.exports = __webpack_public_path__ + "img/bold.0038e1e6.svg";